export const getSearchPostsUrl = ({ searchQuery, pagingToken, limit }) => {
  let params = { search_query: searchQuery };
  if (pagingToken) {
    params.paging_token = pagingToken;
  }
  if (limit) {
    params.limit = limit;
  }
  return { url: "/api/v1/posts/search", config: { params: params } };
};

export default {
  getSearchPostsUrl,
};



// WEBPACK FOOTER //
// ./src/api/SearchApi.js